import {dateToUtc} from "./date-to-utc";
import {addDaysInZone} from "./add-days-in-zone";

/**
 * @hidden
 */
export function dateToExclusiveEndUtc(date: Date | string, zone: string, truncate?: boolean): Date;

/**
 * @hidden
 */
export function dateToExclusiveEndUtc(date: undefined, zone: string, truncate?: boolean): undefined;

/**
 * @hidden
 */
export function dateToExclusiveEndUtc(date: null, zone: string, truncate?: boolean): null;

/**
 * @hidden
 */
export function dateToExclusiveEndUtc(date: Date | string | undefined, zone: string, truncate?: boolean): Date | undefined;

/**
 * @hidden
 */
export function dateToExclusiveEndUtc(date: Date | string | null, zone: string, truncate?: boolean): Date | null;

export function dateToExclusiveEndUtc(date: Date | string | undefined, zone: string, truncate?: boolean): Date | undefined;

/**
 * Returns a Date in UTC that is at the start of the next day in the specified zone. For example, if zone is
 * 'Pacific/Auckland' then it can return '2021-12-31T11:00:00Z', which is the start of 1st January 2022 in the
 * `Pacific/Auckland' zone. However, it won't return '2021-12-31T12:00:00Z', because this is 1am on 1st January 2022
 * in the 'Pacific/Auckland' zone and not at the start of the day so an error could be thrown instead.
 *
 * If date is an iso date string (YYYY-MM-DD) then it will be validated and converted using the specified zone to
 * the start of the next day.
 *
 * If date is a Date then it will be validated that it occurs at the start of a day in the specified zone.
 *
 * @param date
 * @param zone the time zone descriptor, usually an offset or IANA time zone name (e.g. America/Los_Angeles)
 */
export function dateToExclusiveEndUtc(date: Date | string | undefined | null, zone: string, truncate = false): Date | undefined | null {
  if (typeof date === 'undefined') {
    return undefined;
  } else if (date === null) {
    return null;
  } else if (typeof date === 'string') {
    // date is to date inclusive and result needs to be date time exclusive
    // we need to add 1 day
    return addDaysInZone(dateToUtc(date, zone, truncate), 1, zone);
  } else {
    return dateToUtc(date, zone, truncate)
  }
}
